import request from '@/utils/request'

// 查询健康科普视频列表
export function getHealthVideoList(data) {
  return request({
    url: '/newMall/healthVideo/getHealthVideoList',
    method: 'get',
    data
  })
}

// 新增科普视频
export function createHealthVideo(data) {
  return request({
    url: '/newMall/healthVideo/createHealthVideo',
    method: 'post',
    data
  })
}

// 更新科普视频
export function updateHealthVideo(data) {
  return request({
    url: '/newMall/healthVideo/updateHealthVideo',
    method: 'post',
    data
  })
}

// 查询科普视频
export function getHealthVideo(data) {
  return request({
    url: '/newMall/healthVideo/getHealthVideo',
    method: 'get',
    data
  })
}

// 批量上线健康科普视频
export function batchOnlineHealthVideo(data) {
  return request({
    url: '/newMall/healthVideo/batchOnlineHealthVideo',
    method: 'post',
    data
  })
}

// 批量下线健康科普视频
export function batchOfflineHealthVideo(data) {
  return request({
    url: '/newMall/healthVideo/batchOfflineHealthVideo',
    method: 'post',
    data
  })
}

// 批量删除健康科普视频
export function batchDeleteHealthVideo(data) {
  return request({
    url: '/newMall/healthVideo/batchDeleteHealthVideo',
    method: 'post',
    data
  })
}

// 新增健康科普活动
export function createHealthActivity(data) {
  return request({
    url: '/newMall/healthActivity/createHealthActivity',
    method: 'post',
    data
  })
}

// 查询健康科普活动
export function getHealthActivity(data) {
  return request({
    url: '/newMall/healthActivity/getHealthActivity',
    method: 'get',
    data
  })
}

// 更新健康科普活动
export function updateHealthActivity(data) {
  return request({
    url: '/newMall/healthActivity/updateHealthActivity',
    method: 'post',
    data
  })
}


// 查询健康科普活动列表
export function getHealthActivityList(data) {
  return request({
    url: '/newMall/healthActivity/getHealthActivityList',
    method: 'get',
    data
  })
}


// 批量上线健康科普活动
export function batchOnlineHealthActivity(data) {
  return request({
    url: '/newMall/healthActivity/batchOnlineHealthActivity',
    method: 'post',
    data
  })
}

// 批量下线健康科普活动
export function batchOfflineHealthActivity(data) {
  return request({
    url: '/newMall/healthActivity/batchOfflineHealthActivity',
    method: 'post',
    data
  })
}

// 批量下线健康科普活动
export function getHealthColumnList(data) {
  return request({
    url: '/newMall/healthColumn/getHealthColumnList',
    method: 'GET',
    data
  })
}

// 查询健康科普文章列表
export function getHealthArticleList(data) {
  return request({
    url: '/newMall/healthArticle/getHealthArticleList',
    method: 'get',
    data
  })
}


//查询健康科普楼层列表
export function getFloorList(data) {
  return request({
    url: '/newMall/healthFloor/getHealthFloorList',
    method: 'get',
    data
  })
}

//查询健康科普楼层详情
export function getFloorDetail(data) {
  return request({
    url: '/newMall/healthFloor/getHealthFloor',
    method: 'get',
    data
  })
}

//批量健康科普上线楼层
export function batchOnlineFloor(data) {
  return request({
    url: '/newMall/healthFloor/batchOnlineHealthFloor',
    method: 'post',
    data
  })
}

//批量健康科普下线楼层
export function batchOfflineFloor(data) {
  return request({
    url: '/newMall/healthFloor/batchOfflineHealthFloor',
    method: 'post',
    data
  })
}

//新增健康科普自营商城楼层
export function createActivityFloor(data) {
  return request({
    url: '/newMall/healthFloor/createHealthFloor',
    method: 'post',
    data
  })
}


//更新健康科普楼层
export function updateActivityFloor(data) {
  return request({
    url: '/newMall/healthFloor/updateHealthFloor',
    method: 'post',
    data
  })
}

// //上移健康科普楼层
// export function upActivityFloor(data) {
//   return request({
//     url: '/newMall/activityFloor/upActivityFloor',
//     method: 'post',
//     data
//   })
// }

// //下移健康科普楼层
// export function downActivityFloor(data) {
//   return request({
//     url: '/newMall/activityFloor/downActivityFloor',
//     method: 'post',
//     data
//   })
// }

// //置顶健康科普楼层
// export function topActivityFloor(data) {
//   return request({
//     url: '/newMall/activityFloor/topActivityFloor',
//     method: 'post',
//     data
//   })
// }










// WEBPACK FOOTER //
// ./src/api/shop/healthManage.js